import { render, staticRenderFns } from "./BuyBoxCountrySwitcher.vue?vue&type=template&id=76b2ea5a&scoped=true"
import script from "./BuyBoxCountrySwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxCountrySwitcher.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxCountrySwitcher.vue?vue&type=style&index=0&id=76b2ea5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b2ea5a",
  null
  
)

export default component.exports